export default __webpack_public_path__ + "static/media/d1.3f637887.png";